<!--https://paulund.co.uk/add-telephone-number-links-with-html5-->
@if (this.isLinkEnabled) {
  <span><a href="tel:{{this.phoneNumber}}"> {{ this.phoneNumber | phoneNumber }}</a></span>
}
@if (!this.isLinkEnabled) {
  <span> {{ this.phoneNumber | phoneNumber }}</span>
}



